import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// --- Services ---
import { LoggingService } from '@services/logging.service';
import { ErrorService } from '@services/error.service';
import { NotificationService } from '@services/notification.service';

@Injectable()
export class GlobalErrorInterceptor implements ErrorHandler {
	// Error handling is important and needs to be loaded first.
	// Because of this we should manually inject the services with Injector.
	constructor(private _injector: Injector) {}

	handleError(error: Error | HttpErrorResponse) {
		const errorService = this._injector.get(ErrorService);
		const logger = this._injector.get(LoggingService);
		const notifier = this._injector.get(NotificationService);

		let message = '';
		let stackTrace = '';

		if (error instanceof HttpErrorResponse) {
			// Server Error
			message = errorService.getServerMessage(error);
			stackTrace = errorService.getServerStack(error) || '';
			notifier.showError(message);
		} else {
			// Client Error
			message = errorService.getClientMessage(error);
			stackTrace = errorService.getClientStack(error) || '';
			notifier.showError(message);
		}

		// Always log errors
		logger.logError(message, stackTrace);

		console.error(error);
	}
}
